import React, { Component } from "react";
import TopNav from "../containers/TopNav/TopNav";
import TranslatedPage from "../containers/TranslatedPage/TranslatedPage";
import Footer from "../containers/Footer";
import AppWrapper from "../containers/AppWrapper";

class TermsOfUse extends Component {
  render() {
    return (
      <AppWrapper>
        <TopNav />

        <section className="gray-bg">
          <div className="main-container">
            <div className="content-wrapper">
              <h1>
                <TranslatedPage path="terms-of-use.content_blocks.terms_of_use.heading" />
              </h1>
              <hr />
              <TranslatedPage path="terms-of-use.content_blocks.terms_of_use.content" />
            </div>
          </div>
        </section>

        <Footer />
      </AppWrapper>
    );
  }
}

export default TermsOfUse;
